<template>
  <div
    :class="`app-feature-icon__image ${src}`"
    :style="`background-color: ${color}`"
  />
</template>

<script>
export default {
  name: 'AppFeatureIcon',
  props: {
    src: {
      type: String
    },
    color: {
      type: String,
      default: '#000'
    }
  }
}
</script>

<style scoped>
.app-feature-icon__image {
  display: flex;
  flex-shrink: 0;
  flex-grow: 0;
  opacity: 0.2;
  margin-bottom: 0.75rem;
  mask-size: contain;
  mask-position: center;
  mask-repeat: no-repeat;
}

.gps {
  mask-image: url("/static/icons/gps@3x.png");
}

.wifi {
  mask-image: url("/static/icons/wifi@3x.png");
}

.alarm {
  mask-image: url("/static/icons/alarm@3x.png");
}

.watch {
  mask-image: url("/static/icons/watch@3x.png");
}

.print {
  mask-image: url("/static/icons/print@3x.png");
}

.toggle {
  mask-image: url("/static/icons/toggle@3x.png");
}
</style>
